import { RecaptchaSettingsDTO } from '../data/dtos/recaptcha-settings.dto';

export class RecaptchaSettingsService {
    setReCaptchaScript(settings: RecaptchaSettingsDTO) {
        if (settings.IsEnabled) {
            const reCapatcha = document.createElement('script');
            reCapatcha.type = 'text/javascript';
            reCapatcha.src = `https://www.google.com/recaptcha/api.js?render=${settings.SiteKey}`;
            const script = document.getElementsByTagName('script')[0];
            script.parentNode.insertBefore(reCapatcha, script);
        }
    }
}
